import React, { useState, useContext, useEffect } from 'react';
import {
  Button,
  Radio,
  RadioGroup,
  Input,
  Checkbox,
  Snackbar,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  Select,
  TextField,
  MenuItem,
  Menu,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from './InspectorReview.styles';
import surveyImage from '../../../assets/images/survey.png';

const InspectorReview = props => {
  const { classes } = props;

  return (
    <React.Fragment>
      {/* row-between-center : orientation */}
      <div className={cn('flex-1', 'col-center-center', 'px-20')}>
        <img src={surveyImage} style={{ width: 300 }} />

        <h3>Survey Complete!</h3>
        <div>Well done, please hit submit to finalize your survey.</div>
      </div>
    </React.Fragment>
  );
};

InspectorReview.propTypes = {};

InspectorReview.defaultProps = {};

export default withStyles(styles)(InspectorReview);
